import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import ProDrillDownHeader from '../proPanels/ProDrillDownHeader';
import SkillsTable from '../tables/SkillsTable';
import { DrillDownScatter } from '../scatterPlots/DrillDownScatter';
import { Stack } from '@mui/system';

/** @component
 *  Renders the skills tab for mobile.
 * @param focusedDot {Object} - currently selected portfolio
 * @param skillsData {Array<Object>} - skills data array for currently selected portfolio
 * @returns {Element}
 * @constructor
 */
const SkillsTab = ({ focusedDot, skillsData }) => {
    return (
        <Stack spacing={3} alignContent={'center'}>
            <Typography
                variant='headerMobile'
                textAlign='left'
                sx={{ paddingLeft: 2, paddingTop: 2 }}
            >
                Breakdown by Skill
            </Typography>
            <ProDrillDownHeader selectedDot={focusedDot} />
            <SkillsTable data={skillsData} />
            <DrillDownScatter data={skillsData} />
        </Stack>
    );
};

SkillsTab.propTypes = {
    focusedDot: PropTypes.object,
    skillsData: PropTypes.arrayOf(PropTypes.object)
};

export default SkillsTab;
